/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  DeleteTeamsInvitationsInvitationidMutationResponse,
  DeleteTeamsInvitationsInvitationidPathParams,
  DeleteTeamsInvitationsInvitationid400,
  DeleteTeamsInvitationsInvitationid401,
  DeleteTeamsInvitationsInvitationid403,
  DeleteTeamsInvitationsInvitationid404,
  DeleteTeamsInvitationsInvitationid500,
} from "../types/DeleteTeamsInvitationsInvitationid.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  UseMutationOptions,
  UseMutationResult,
  QueryClient,
} from "@tanstack/react-query";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const deleteTeamsInvitationsInvitationidMutationKey = () =>
  [{ url: "/teams/invitations/:invitationId" }] as const;

export type DeleteTeamsInvitationsInvitationidMutationKey = ReturnType<
  typeof deleteTeamsInvitationsInvitationidMutationKey
>;

/**
 * @summary Отменить приглашение в команду
 * {@link /teams/invitations/:invitationId}
 */
export async function deleteTeamsInvitationsInvitationid(
  invitationId: DeleteTeamsInvitationsInvitationidPathParams["invitationId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    DeleteTeamsInvitationsInvitationidMutationResponse,
    ResponseErrorConfig<
      | DeleteTeamsInvitationsInvitationid400
      | DeleteTeamsInvitationsInvitationid401
      | DeleteTeamsInvitationsInvitationid403
      | DeleteTeamsInvitationsInvitationid404
      | DeleteTeamsInvitationsInvitationid500
    >,
    unknown
  >({
    method: "DELETE",
    url: `/teams/invitations/${invitationId}`,
    ...requestConfig,
  });
  return res;
}

export function deleteTeamsInvitationsInvitationidMutationOptions<
  TContext = unknown,
>(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const mutationKey = deleteTeamsInvitationsInvitationidMutationKey();
  return mutationOptions<
    ResponseConfig<DeleteTeamsInvitationsInvitationidMutationResponse>,
    ResponseErrorConfig<
      | DeleteTeamsInvitationsInvitationid400
      | DeleteTeamsInvitationsInvitationid401
      | DeleteTeamsInvitationsInvitationid403
      | DeleteTeamsInvitationsInvitationid404
      | DeleteTeamsInvitationsInvitationid500
    >,
    {
      invitationId: DeleteTeamsInvitationsInvitationidPathParams["invitationId"];
    },
    TContext
  >({
    mutationKey,
    mutationFn: async ({ invitationId }) => {
      return deleteTeamsInvitationsInvitationid(invitationId, config);
    },
  });
}

/**
 * @summary Отменить приглашение в команду
 * {@link /teams/invitations/:invitationId}
 */
export function useDeleteTeamsInvitationsInvitationid<TContext>(
  options: {
    mutation?: UseMutationOptions<
      ResponseConfig<DeleteTeamsInvitationsInvitationidMutationResponse>,
      ResponseErrorConfig<
        | DeleteTeamsInvitationsInvitationid400
        | DeleteTeamsInvitationsInvitationid401
        | DeleteTeamsInvitationsInvitationid403
        | DeleteTeamsInvitationsInvitationid404
        | DeleteTeamsInvitationsInvitationid500
      >,
      {
        invitationId: DeleteTeamsInvitationsInvitationidPathParams["invitationId"];
      },
      TContext
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { mutation = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...mutationOptions } = mutation;
  const mutationKey =
    mutationOptions.mutationKey ??
    deleteTeamsInvitationsInvitationidMutationKey();

  const baseOptions = deleteTeamsInvitationsInvitationidMutationOptions(
    config,
  ) as UseMutationOptions<
    ResponseConfig<DeleteTeamsInvitationsInvitationidMutationResponse>,
    ResponseErrorConfig<
      | DeleteTeamsInvitationsInvitationid400
      | DeleteTeamsInvitationsInvitationid401
      | DeleteTeamsInvitationsInvitationid403
      | DeleteTeamsInvitationsInvitationid404
      | DeleteTeamsInvitationsInvitationid500
    >,
    {
      invitationId: DeleteTeamsInvitationsInvitationidPathParams["invitationId"];
    },
    TContext
  >;

  return useMutation<
    ResponseConfig<DeleteTeamsInvitationsInvitationidMutationResponse>,
    ResponseErrorConfig<
      | DeleteTeamsInvitationsInvitationid400
      | DeleteTeamsInvitationsInvitationid401
      | DeleteTeamsInvitationsInvitationid403
      | DeleteTeamsInvitationsInvitationid404
      | DeleteTeamsInvitationsInvitationid500
    >,
    {
      invitationId: DeleteTeamsInvitationsInvitationidPathParams["invitationId"];
    },
    TContext
  >(
    {
      ...baseOptions,
      mutationKey,
      ...mutationOptions,
    },
    queryClient,
  ) as UseMutationResult<
    ResponseConfig<DeleteTeamsInvitationsInvitationidMutationResponse>,
    ResponseErrorConfig<
      | DeleteTeamsInvitationsInvitationid400
      | DeleteTeamsInvitationsInvitationid401
      | DeleteTeamsInvitationsInvitationid403
      | DeleteTeamsInvitationsInvitationid404
      | DeleteTeamsInvitationsInvitationid500
    >,
    {
      invitationId: DeleteTeamsInvitationsInvitationidPathParams["invitationId"];
    },
    TContext
  >;
}
